// extracted by extract-css-chunks-webpack-plugin
module.exports = {"grid":"HomeFeedGrid-06181a3851a8467d","cell":"HomeFeedGrid-a624d8e3e0959f81","cell-full-width":"HomeFeedGrid-573c04a09ddce73e"};